import { Handle, Position } from '@xyflow/react'
import plcLogo from '@/assets/gateway.png'

function OcppGatewayNode({ data, isConnectable }) {
  return (
    <div className="custom-node-plc plc-limits">
      <Handle type="target" position={Position.Left} />

      <div className="grid grid-cols-1">
        <div>
          <div></div>
          <div className="text-center">
            <img src={plcLogo} alt="Gateway Logo" className="custom-node-plc-logo" />
          </div>
          <div className="text-center">
            <b>OCPP Gateway</b>
          </div>
        </div>
      </div>

      <Handle type="source" position={Position.Right} />
    </div>
  )
}

export default OcppGatewayNode
